import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { translate } from "@shape/reef-shared";
import styles from "./MultiValueTag.module.scss";

export interface MultiValueTagProps {
  label: string;
  onRemove?: () => void;
}

export function MultiValueTag({ label, onRemove }: MultiValueTagProps) {
  return (
    <div className={styles.multiValue}>
      <span className={styles.multiValueLabel}>{label}</span>
      {onRemove && (
        <button
          type="button"
          className={styles.multiValueRemove}
          onClick={onRemove}
          data-testid="removeItem"
          aria-label={`${translate("generic.remove")} ${label}`}
          title={translate("generic.remove")}
        >
          <FontAwesomeIcon icon={faTimes} aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
